import React from "react";
import { Col, Row } from "react-bootstrap";
import { isRgbColorEnabled, getScaleColors } from "../../../../../../../Helpers/RgbColorHelper";

export default function Detail_Textual({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  // Find the hit range to display on the left
  const hitRange = item.scale.ranges.find((range) => range.isHit);

  // SVG circular progress component
  const CircularProgress = ({ percentage, score }) => {
    const radius = 50;
    const strokeWidth = 8;
    const normalizedRadius = radius - strokeWidth * 2;
    const circumference = normalizedRadius * 2 * Math.PI;
    const strokeDasharray = `${circumference} ${circumference}`;
    const strokeDashoffset = circumference - (percentage / 100) * circumference;

    // RGB Color logic
    const isRgbEnabled = isRgbColorEnabled(item.scale);
    const rgbColors = isRgbEnabled ? getScaleColors(item.scale) : null;
    const progressColor = isRgbEnabled && rgbColors ? rgbColors.primary : "#17a2b8";
    const backgroundColor = isRgbEnabled && rgbColors ? rgbColors.background : "#e6e6e6";

    return (
      <div className="position-relative d-flex justify-content-center align-items-center">
        <svg height={radius * 2} width={radius * 2} className="transform-rotate-minus-90">
          {/* Background circle */}
          <circle
            stroke={backgroundColor}
            fill="transparent"
            strokeWidth={strokeWidth}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />
          {/* Progress circle */}
          <circle
            stroke={progressColor}
            fill="transparent"
            strokeWidth={strokeWidth}
            strokeDasharray={strokeDasharray}
            style={{ strokeDashoffset }}
            strokeLinecap="round"
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />
        </svg>
        {/* Score text in center */}
        <div
          className="position-absolute d-flex flex-column justify-content-center align-items-center"
          style={{ fontSize: "18px", fontWeight: "bold", color: progressColor }}
        >
          <div>{score}</div>
        </div>
      </div>
    );
  };

  return (
    <Row className={"mb-4 mx-0"}>
      <div className="p-3" style={{ border: "1px solid #e0e0e0", borderRadius: "8px", backgroundColor: "#fff" }}>
        {/* Main layout */}
        <Row className="align-items-stretch">
          <Col xs={2} className="d-flex flex-column justify-content-center align-items-center">
            {item.isSub && item.scopeName && (
              <div className="detail-section-sub-scope-name-header-wrap-up" style={{ fontSize: "14px", color: "#666" }}>
                {item.scopeName}
              </div>
            )}
            {/* Scope name above circular progress */}
            <div
              style={{
                fontSize: "16px",
                fontWeight: "600",
                color: "#333",
                marginBottom: "10px",
                textAlign: "center",
              }}
            >
              {item.name}
            </div>
          </Col>

          {/* Right side - Circular progress and general info */}
          <Col xs={1} className="d-flex flex-column align-items-center">
            {/* Circular progress */}
            <div className="mb-3">
              <CircularProgress percentage={elementScore} score={elementScore} />
            </div>
          </Col>

          {/* Left side - Hit range text */}
          <Col xs={9} className="pe-4">
            {hitRange && (
              <div className="detail-textual-content-box">
                {item.scale.isHtml ? <div dangerouslySetInnerHTML={{ __html: hitRange.text }} /> : hitRange.text}
              </div>
            )}
          </Col>
        </Row>
      </div>
    </Row>
  );
}
